import {differenceInSeconds} from 'date-fns/differenceInSeconds'
import {parseISO} from 'date-fns/parseISO'

import useTimeSelector from '../../../../hooks/useTimeSelector'
import {formatDuration} from '../../../../utils/dateTimeUtils'

const START_SHORTLY_TIME = 60 // in seconds

const useTimeToStart = (startEstimate: string | null | undefined): string | null | undefined =>
  useTimeSelector(now => {
    if (startEstimate != null) {
      const leftInSeconds = differenceInSeconds(parseISO(startEstimate), now)
      return leftInSeconds < START_SHORTLY_TIME
        ? 'Should start shortly'
        : `${formatDuration(leftInSeconds)} to start`
    }

    return null
  })
export function useTitle({
  statusText,
  isQueued = false,
  waitReason,
  startEstimate,
  omitUnknown,
}: {
  statusText: string | null | undefined
  isQueued?: boolean
  waitReason?: string | null | undefined
  startEstimate?: string | null | undefined
  omitUnknown?: boolean
}): string {
  const timeToStart = useTimeToStart(startEstimate)

  if (statusText != null) {
    return statusText
  }

  if (!isQueued) {
    return ''
  }

  return (
    [timeToStart, waitReason].filter(Boolean).join(': ') ||
    (omitUnknown ? '' : 'Unknown time to start')
  )
}
